var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({attrs:{"variant":"light"}},'b-button',_vm.$attrs,false),[_vm._t("default",[_vm._v(_vm._s(_vm.$t('Edit')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }